<template>
    <div class="signin">
        <!--<img class="dzxcsc" src="@/assets/images/dzxcsc.png" />-->
        <el-row type="flex" class="row-bg main" justify="center">
            <el-col :span="20">
                <p class="center">关于我们</p>
                <div class="sides">
                    <a> </a>
                    <a class="short"> </a>
                    <a class="short"> </a>
                    <a class="short"> </a>
                </div>
                <!-- <p>壹米滴答于2015年在上海成立，是业界领先的零担物流平台。最早由区域合伙、联盟发展而来，目前主营业务是全国公路零担物流网络服务，致力于为客户提供高性价比的综合物流服务</p>
                <p>壹米滴答以“让物流更智能，让连接更高效”为使命，凭借特有的联盟策略、精准的规模策略、定向的重投策略、坚实的人才策略等，逐步实现运营模式标准化、经营模式个性化、信息系统可视化、服务时效产品化，从而满足跨行业客户的不同需求，实现“客户首选的、基于物流的综合服务平台”的企业愿景。</p>
                <p>壹米滴答以区域联盟起步，通过资源整合与裂变，把各独立的省内网络“B网”进一步向外扩张并结合自建，形成全国性快运网络的“A网”，最终形成A、B两网融合的创新商业模式。目前，壹米滴答已完成第六轮融资（D轮融资），坐拥国内外多家顶尖财务投资者和产业投资者的资本后盾。</p>
                <p>截至2018年12月，壹米滴答快速完成了全国网络覆盖31个省份（自营省区24个、成员省区7个），并可通达港台。拥有12000多家网点、近1500条干线、2255台车辆、近200个分拨、70万平米操作面积，一二级城市覆盖率100%、区县级覆盖率90%，全国员工16000多名，是全国拥有干支线数量和货量均领先其他同行的零担物流网络平台。</p> -->
                <div class="content" v-html="articleContent"></div>
            </el-col>
        </el-row>
        <div class="signin-main">
            <img class="banner" src="@/assets/images/synopsis-img.jpg" />
            <div class="writing">
                <p>发展历程</p>
                <div class="sides">
                    <a> </a>
                    <a class="short"> </a>
                    <a class="short"> </a>
                    <a class="short"> </a>
                </div>
                <p class="botto" v-for="item in bottolist5" :key="item.index">
                    {{ item.yearDate | formatDatetext }}
                    {{ item.content | wordnumber }}
                </p>
                <!-- <p>不断学习创新，懂得感恩分享，勇于自我批评的价值观</p> -->
                <p @click="history" class="btn">
                    查看更多发展历程 <i class="el-icon-caret-right"></i>
                </p>
            </div>
        </div>
        <el-row type="flex" class="row-bg store" justify="center">
            <el-col :span="20">
                <el-col :span="8">
                    <img
                        class="banner"
                        src="@/assets/images/quanguomendian.png"
                    />
                    <p class="number">
                        <countTo
                            :startVal="startstore"
                            :endVal="endstore"
                            :duration="9000"
                        ></countTo>
                    </p>
                    <p class="language">全国门店</p>
                </el-col>
                <el-col :span="8">
                    <img class="banner" src="@/assets/images/guyuan.png" />
                    <p class="number">
                        <countTo
                            :startVal="startperson"
                            :endVal="endperson"
                            :duration="9000"
                        ></countTo>
                    </p>
                    <p class="language">雇员</p>
                </el-col>
                <el-col :span="8">
                    <img class="banner" src="@/assets/images/cheliang.png" />
                    <p class="number">
                        <countTo
                            :startVal="startcar"
                            :endVal="endcar"
                            :duration="9000"
                        ></countTo>
                    </p>
                    <p class="language">车辆</p>
                </el-col>
            </el-col>
        </el-row>
        <div class="dexter">
            <img class="banner" src="@/assets/images/synopsis-img2.jpg" />
            <div class="writing">
                <p>企业荣誉</p>
                <div class="sides">
                    <a> </a>
                    <a class="short"> </a>
                    <a class="short"> </a>
                    <a class="short"> </a>
                </div>
                <!-- <p>2019年1月15日，荣获铅笔道·真榜·2018年互联网“逆生长”准独角兽公司TOP50</p>
                <p>2018年7月31日，通过ISO9001质量体系认证</p> -->
                <div
                    class="writing1"
                    v-for="item in companyhonor"
                    :key="item.id"
                >
                    <p>{{ item.title | wordnumber }}</p>
                </div>
                <p @click="honor" class="btn">
                    感谢认可，您还可以查看我们更多的奖项<i
                        class="el-icon-caret-right"
                    ></i>
                </p>
            </div>
        </div>
        <!-- <div class="business">
            <p>业务覆盖全国</p>
            <div class="sides">
                <a> </a>
                <a class="short"> </a>
                <a class="short"> </a>
                <a class="short"> </a>
            </div>
            <el-row type="flex" class="row-bg map" justify="center">
                <el-col :span="20">
                    <Atlas />
                </el-col>
            </el-row>
        </div> -->
    </div>
</template>
<script>
import {
    queryarticlebyid,
    findCompanyCount,
    companyhonor,
    selectcompanydev
} from "@/api/apiall";
import countTo from "vue-count-to";
import Atlas from "@/components/map/Atlas";
export default {
    components: {
        countTo,
        Atlas
    },
    data() {
        return {
            bottolist5: [],
            startstore: 0,
            endstore: 0,
            startperson: 0,
            endperson: 0,
            startcar: 0,
            endcar: 0,
            category: "",
            articleContent: "",
            companyhonor: []
        };
    },
    created() {
        this.category = this.$route.query.id;
        this.aueryfindbytype();
        this.company();
        this.searchtitle();
        this.searchfind();
    },
    methods: {
        searchtitle() {
            selectcompanydev({ platform: 1 }).then(res => {
                if (res.status === 2000) {
                    this.bottolist5 = res.data;
                }
            });
        },
        searchfind() {
            findCompanyCount({ type: "companyIntroduce" }).then(res => {
                if (res.status === 2000) {
                    this.endperson = parseInt(res.data.employeeNumber);
                    this.endstore = parseInt(res.data.storesNumber);
                    this.endcar = parseInt(res.data.carNumber);
                }
            });
        },
        company() {
            companyhonor({
                categoryId: "455C225F-C9CC-963F-46E2-A7C8EEBE701E",
                platform: "1"
            }).then(res => {
                if (res.status == 2000) {
                    this.companyhonor = res.data;
                }
            });
        },
        aueryfindbytype() {
            queryarticlebyid({ categoryId: this.category, platform: "1" }).then(
                res => {
                    if (res.status === 2000) {
                        this.articleContent = res.data.osArticleContent.content;
                    }
                }
            );
        },
        history() {
            this.$router.push({
                path: "/introduction/chronicle",
                query: {
                    id: "0E88B4CB-F706-A9C1-707B-F2200549FE23"
                }
            });
        },
        honor() {
            this.$router.push({
                path: "/introduction/honor",
                query: {
                    id: "455C225F-C9CC-963F-46E2-A7C8EEBE701E"
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.signin {
    margin-bottom: 10px;
    position: relative;
    .dzxcsc{
        position: absolute;
        right: 0;
        top: -30px;
        width: 100px;
    }
    .main {
        // text-align: center;
        position: relative;
        p:nth-child(1) {
            font-size: 24px;
            margin-top: 60px;
        }
        .sides {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
        .content {
            white-space: pre-line;
            word-wrap: break-word;
            word-break: break-all;
            margin-top: 50px;
            p:nth-child(3) {
                margin-top: 60px;
            }
            p:nth-child(4) {
                margin-top: 10px;
            }
            p {
                line-height: 24px;
                font-size: 16px;
                text-align: left;
                margin-top: 16px;
            }
        }

        .btn {
            margin-top: 32px;
            color: #fabe00;
            cursor: pointer;
        }
    }
    .signin-main {
        position: relative;
        margin-top: 60px;
        .banner {
            width: 100%;
        }
        .writing {
            position: absolute;
            top: 20%;
            left: 10%;
            p:nth-child(1) {
                font-size: 24px;
            }
            .btn {
                margin-top: 22px;
                color: #fabe00;
                cursor: pointer;
            }
            .botto {
                width: 500px;
                line-height: 26px;
                margin-top: 16px;
                font-size: 16px;
                color: #fff;
            }
        }
    }
    .store {
        margin-top: 100px;
        margin-bottom: 100px;
        .el-col {
            text-align: center;
            .number {
                font-size: 39px;
                margin-top: 50px;
            }
            .language {
                font-size: 17px;
                margin-top: 14px;
            }

            .content {
                white-space: pre-line;
                word-wrap: break-word;
                word-break: break-all;
                // margin-top: 60px;
                p {
                    font-size: 14px;
                    color: #666;
                    margin-top: 20px;
                }
                p:nth-child(1),
                p:nth-child(8),
                p:nth-child(10) {
                    font-size: 16px;
                    margin-top: 30px;
                    font-weight: 500;
                    color: #000;
                }
            }
        }
    }
    .dexter {
        position: relative;
        .banner {
            width: 100%;
        }
        .writing {
            position: absolute;
            top: 20%;
            left: 62%;
            p:nth-child(1) {
                font-size: 24px;
            }
            p {
                line-height: 36px;
                font-size: 16px;
                color: #fff;
            }
            > div {
                p {
                    font-size: 16px !important;
                }
            }
            .btn {
                margin-top: 22px;
                color: #fabe00;
                cursor: pointer;
            }
        }
    }
    .center {
        text-align: center !important;
    }
    .business {
        margin-top: 100px;
        text-align: center;
        .sides {
            overflow: hidden;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
        p {
            font-size: 24px;
        }
        .map {
            overflow: hidden;
        }
    }
}
</style>
